<template>
  <div
    v-loading="loading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    fullscreen="true"
    style="height: 1000px"
  >
    <iframe
      :src="`${serverBaseURL}/signin/client?redirect_url=${baseURL}/sso-signin`"
      style="display: none"
    ></iframe>
  </div>
</template>

<script>
import appConfig from "@/config/app";
export default {
  data() {
    return {
      event: {},
      loading: true,
      serverBaseURL: appConfig.AUTHFAST_BASE_URL,
      baseURL: window.location.origin,
    };
  },
  created() {
    window.addEventListener("message", this.handleIframeMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleIframeMessage);
  },
  methods: {
    handleIframeMessage(event) {
      this.event = event;
      if (event.data?.type === "iframeLoad") {
        window.location.href = this.$route.query.target_url;
      }
    },
  },
};
</script>
